import React, { useState, useEffect } from 'react';
import { Segmented, Tooltip } from 'antd';
import { StyledTooltipIcon } from '../../styled';
import Line from './Chart';
import { StyledLineHeader } from './styled';
import { getLineData } from './utils';

const LinePanel = ({ data }) => {
  const [selected, setSelected] = useState<string>('kpiSampleSize');
  const [lineData, setLineData] = useState({
    series: [],
    categories: [],
    dates: [],
  });

  useEffect(() => {
    const lineData = getLineData(data, selected);
    setLineData(lineData);
  }, [data, selected]);

  return (
    <>
      <StyledLineHeader>
        <h3>
          CDN Resources - Impact Avoidance Breakdown
          <Tooltip title="Top 20">
            <StyledTooltipIcon />
          </Tooltip>
        </h3>
        <Segmented
          defaultValue={selected}
          options={[
            {
              label: 'KPI Sample Size',
              value: 'kpiSampleSize',
            },
            {
              label: 'Duration',
              value: 'duration',
            },
          ]}
          onChange={(value) => {
            setSelected(String(value));
          }}
        />
      </StyledLineHeader>
      <Line data={lineData} type={selected} />
    </>
  );
};

export default React.memo(LinePanel);
